
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
import { ActivityPeriodSummary, DateValue, RentalInfo, RentalKPI } from 't4core';


export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MMMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    styleUrls: ['./home.css'],
    selector: 'home',
    templateUrl: './home.component.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class HomeComponent extends PageBase implements OnInit {
    private _fromDate: Moment = moment().startOf('month');
    private _toDate: Moment = moment().endOf('month');

    public get fromDate(): Moment { return this._fromDate; }
    public set fromDate(value: Moment) { this._fromDate = value; }

    public get toDate(): Moment { return this._toDate; }
    public set toDate(value: Moment) { this._toDate = value; }

    public autoFontSize: string = 'auto';
    public autoHeight: string = 'auto';

    @ViewChild("Panel", {static: false}) public averagePricePanel: ElementRef;
    public averagePrice: RentalKPI = { Key: "AveragePrice", Value: 0, RelatedValue: 0, Delta: 1 };
    public totalPickups: RentalKPI = { Key: "TotalPickups", Value: 0, RelatedValue: 0, Delta: 1 };
    public failedToProvide: RentalKPI = { Key: "FailedToProvide", Value: 0, RelatedValue: 0, Delta: 1 };
    public averageLength: RentalKPI = { Key: "AverageLength", Value: 0, RelatedValue: 0, Delta: 1 };
    public lateBookings: RentalInfo[];

    public salesData = [];
    public activityData = [];
    public webPercentageData = [{
        label: '2018',
        data: [50, 50],
        backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
        hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
    },
    {
        label: '2017',
        data: [50, 50],
        backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
        hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
    }];
    public webPercentOptions = {
        responsive: true,
        scales: {
            yAxes: [{
                ticks: {
                    callback: function (value, index, values) { return value + '%'; }
                }
            }]
        }
    };

    public monthLabels = [];

    public chartColors: Array<any> = [
        {
            backgroundColor: 'rgba(151,205,151,0)',
            borderColor: 'rgba(151,205,151,0.5)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(151,205,151,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,205,151,0.5)'
        },
        {
            backgroundColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(151,187,205,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,1)'
        },
        {
            backgroundColor: 'rgba(151,187,205,0)',
            borderColor: 'rgba(151,187,205,0.5)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(151,187,205,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,0.5)'
        },
        {
            backgroundColor: 'rgba(205,151,151,0)',
            borderColor: 'rgba(205,151,151,0.5)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(0,0,0,0)'
        },
        {
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.25)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(0,0,0,0.5)'
        }
    ];
    public chartOptions: any = {
        responsive: true,
        scales: {
            yAxes: [{
                stacked: false,
                position: "left",
                id: "y-axis-0",

            },
                {
                    stacked: false,
                    position: "right",
                    id: "y-axis-1",

                }],
            xAxes: [{
                type: 'time',
                time: {
                    format: 'YYYY-MM-DD',
                    unit: 'week',
                    unitStepSize: 1,
                    bounds: 'data',
                    tooltipFormat: 'ddd D/M [v]w',
                    displayFormats: {
                        week: '[v]W'
                    }
                }
            }]
        }
    };
    public salesChartColors: Array<any> = [
        {
            backgroundColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(151,187,205,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,1)'
        },
        {
            backgroundColor: 'rgba(151,187,205,0)',
            borderColor: 'rgba(151,187,205,0.5)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(151,187,205,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,0.5)'
        },
        {
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.5)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(0,0,0,0.5)'
        },
        {
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.25)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(0,0,0,0.5)'
        },
        {
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.1)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(0,0,0,0.5)'
        }
    ];
    public salesChartOptions: any = {
        responsive: true,
        scales: {
            yAxes: [{
                stacked: false,
                position: "left",
                id: "y-axis-0",
                ticks: {
                    suggestedMax: 1200,
                    suggestedMin: 1100,
                }
            },
                {
                    stacked: false,
                    position: "right",
                    id: "y-axis-1",
                    ticks: {
                        callback: function (value, index, values) { return value + '%'; }
                    }
                }],
            xAxes: [{
                type: 'time',
                time: {
                    format: 'YYYY-MM-DD',
                    unit: 'week',
                    unitStepSize: 1,
                    bounds: 'data',
                    tooltipFormat: 'ddd D/M [v]w',
                    displayFormats: {
                        week: '[v]W'
                    }
                }
            }]
        }
    };



    constructor(el: ElementRef) {
        super(el, "FleetManagement");
    }

    public async ngOnInit() {
        this.loadData();
    }

    public loading = {
        kpi: false,
        activity: false,
        turnover: false,
        late: false
    }

    public async loadData() {
        this.salesChartOptions.scales.xAxes[0].time.min = this.fromDate.startOf('month').format("YYYY-MM-DD");
        this.salesChartOptions.scales.xAxes[0].time.max = this.toDate.endOf('month').format("YYYY-MM-DD");

        //this.chartTurnover.ngOnChanges({});

        this.fromDate = this.fromDate.clone();
    }
}
